import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material';

import { HelperService } from '../service/helper/helper.service';
import { ApiService } from '../service/api/api.service';
import { ModalComponent } from '../modal/modal.component';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-txhistory',
  templateUrl: './txhistory.component.html',
  styleUrls: ['./txhistory.component.css']
})

export class TxhistoryComponent implements OnInit, OnChanges {
  public IntransactionList = [{tx:{}}];
  public OuttransactionList = [{tx:{}}];
  public InTxSubList = [{tx:{}}];
  public OutTxSubList  = [{tx:{}}];
  public inCurrSlice = 0;
  public outCurrSlice = 0;
  public totalOutSlice;
  public totalInSlice;
  public InTxListLength = 0;
  public OutTxListLength = 0;
  public fetchingDta = true;
  public processing = true;
  public txObject;
  public JSON;
  public Out = true;
  public address;
  OutSearchPage: string;
  InSearchPage: string;
  totalOutPages: number;
  totalInPages: number;
  constructor(public api : ApiService, public dialog: MatDialog,public router: Router, public helper: HelperService) {
    this.JSON = JSON;
  }

  ngOnInit() {
    this.address = this.helper.getAddress();
    this.showInTxHistory(0);
    this.showOutTxHistory(0)
    //this.PageNo();
    this.helper.selAcc.subscribe(x=>{
      console.log(this.helper.accountListBalance);
      this.address = this.helper.getAddress();
    this.showInTxHistory(0);
    this.showOutTxHistory(0)
    //this.PageNo();

    })
  }
  ngOnChanges(changes: SimpleChanges) {

  }
  backToDashboard() {
    this.router.navigate(['dashboard'])
  }

  openDialog() {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id: 1
    };
    dialogConfig.minWidth='300px'

    dialogConfig.position = {
      top:'68px',
      right: '0',

    };
    this.dialog.open(ModalComponent, dialogConfig);
  }

  showInTxHistory(slice){
    // this.api.getTxHistory(this.helper.accountList[this.helper.slectedAddress],0)
    this.api.getInTxHistory(this.address,slice)
    .subscribe(res => {
      console.log(slice)
      console.log(res.json())
      this.IntransactionList = res.json().data;
      this.totalInSlice = res.json().total/10;
      this.totalInPages = (this.totalInSlice>parseInt(this.totalInSlice.toString()))?(parseInt(this.totalInSlice.toString())+1):parseInt(this.totalInSlice.toString());
      this.inCurrSlice = slice;
      this.InTxListLength = res.json().total;
      console.log(this.InTxListLength)
      this.processing = false;
    })
  }

  showOutTxHistory(slice){
    // this.api.getTxHistory(this.helper.accountList[this.helper.slectedAddress],0)
    this.api.getOutTxHistory(this.address,slice)
    .subscribe(res => {
      console.log(res.json())
      this.OuttransactionList = res.json().data;
      this.totalOutSlice = res.json().total/10;
      this.totalOutPages = (this.totalOutSlice>parseInt(this.totalOutSlice.toString()))?(parseInt(this.totalOutSlice.toString())+1):parseInt(this.totalOutSlice.toString());
      this.outCurrSlice = slice;
      this.OutTxListLength = res.json().total;
      console.log(this.OutTxListLength)
      this.processing = false;
    })
  }

  toggleOutFromOut(){
    if(this.Out != true){
      this.Out = true;
    }
  }
  toggleOutFromIn(){
    if(this.Out != false){
      this.Out = false;
    }
  }

  PageNo(){

  }
  jumpEvent(pageNumber,$usedFor){
    if ($usedFor=='intx') {
      if(pageNumber <= this.totalInPages && pageNumber > 0){
        this.showInTxHistory(pageNumber-1);
        console.log(pageNumber)
        this.InSearchPage = '';
      }
      else{
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: 'Please enter valid page!',
        })
        this.InSearchPage = '';
      }
    }
    else if($usedFor=='outtxs') {
      console.log('pageNumber ', pageNumber, ' totalOutSlice ', this.totalOutSlice)
      if(pageNumber <= this.totalOutPages && pageNumber > 0){
        this.showOutTxHistory(pageNumber-1);
        console.log(pageNumber)
        this.OutSearchPage = '';
      }
      else{
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: 'Please enter valid page!',
        })
        this.OutSearchPage = '';
      }
    }
  }
}
